import BlockLink from '@/components/BlockLink';
import React from 'react';
import Tag from './Tag/Tag';

interface titleImageObject {
  link: string;
  width: number;
  height: number;
  title: string;
}

export interface FeatureCardMainProps {
  showTitle: boolean;
  internalLinkFirstCategory?: string;
  subTitle?: string;
  titleImage?: titleImageObject;
  title?: string;
  date?: string;
  content?: string;
  largeHeading?: boolean;
  smallHeading?: boolean;
  linkText;
  linkExternal;
  linkInternal;
}

const FeatureCardMain: React.FC<FeatureCardMainProps> = ({
  showTitle,
  internalLinkFirstCategory,
  subTitle,
  titleImage,
  title,
  date,
  content,
  largeHeading,
  smallHeading,
  linkText,
  linkExternal,
  linkInternal,
}) => (
  <div className="feature-card__main" data-aos="fade-in">
    {internalLinkFirstCategory && <Tag title={internalLinkFirstCategory} />}

    {subTitle && <p className="feature-card__subtitle h6">{subTitle}</p>}

    {titleImage && titleImage.link ? (
      <img
        className="feature-card__image-heading"
        src={titleImage.link}
        loading="lazy"
        width={titleImage.width}
        height={titleImage.height}
        alt={titleImage.title}
      />
    ) : showTitle ? (
      <h2
        className={`feature-card__heading
            ${smallHeading ? 'feature-card__heading--small h4' : ''}
            ${!largeHeading ? 'h3' : ''}
          `}
      >
        {renderTitle(title)}
      </h2>
    ) : (
      ''
    )}

    {date && <p className="feature-card__date">{date}</p>}

    <div
      className="feature-card__content"
      dangerouslySetInnerHTML={{ __html: content }}
    />

    {linkText && (
      <BlockLink
        linkText={linkText}
        linkExternal={linkExternal}
        linkInternal={linkInternal}
        buttonStyle={linkInternal && 'primary'}
        extraClasses="feature-card__button"
      />
    )}
  </div>
);

const renderTitle = (title) => {
  if (title.includes('<br>')) {
    // Split the string by different types of break tags
    const parts = title.split(/<br\s*\/?>/i);

    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <br />}
      </React.Fragment>
    ));
  }

  return title;
};

export default FeatureCardMain;
